import React, { useState } from 'react'

interface ImageCarouselProps {
  images: string[]
  alt?: string
  height?: number
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images, alt = '', height = 120 }) => {
  const [index, setIndex] = useState(0)

  if (images.length === 0) return null

  if (images.length === 1) {
    return (
      <img
        src={images[0]}
        alt={alt}
        data-testid="carousel-image"
        style={{ width: '100%', height, objectFit: 'cover', borderRadius: 6, display: 'block' }}
      />
    )
  }

  return (
    <div data-testid="image-carousel" style={{ position: 'relative', width: '100%' }}>
      <img
        src={images[index]}
        alt={`${alt} ${index + 1}/${images.length}`}
        data-testid="carousel-image"
        style={{ width: '100%', height, objectFit: 'cover', borderRadius: 6, display: 'block' }}
      />

      {/* Navigation arrows */}
      <button
        type="button"
        data-testid="carousel-prev"
        onClick={e => { e.stopPropagation(); setIndex(i => (i - 1 + images.length) % images.length) }}
        style={{
          position: 'absolute', left: 4, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,.45)', color: '#fff', border: 'none', borderRadius: '50%',
          width: 28, height: 28, cursor: 'pointer', fontSize: '1rem', lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        aria-label="Image précédente"
      >
        ‹
      </button>
      <button
        type="button"
        data-testid="carousel-next"
        onClick={e => { e.stopPropagation(); setIndex(i => (i + 1) % images.length) }}
        style={{
          position: 'absolute', right: 4, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,.45)', color: '#fff', border: 'none', borderRadius: '50%',
          width: 28, height: 28, cursor: 'pointer', fontSize: '1rem', lineHeight: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        aria-label="Image suivante"
      >
        ›
      </button>

      {/* Dots */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 4, marginTop: 4 }}>
        {images.map((_, i) => (
          <span
            key={i}
            data-testid={`carousel-dot-${i}`}
            onClick={e => { e.stopPropagation(); setIndex(i) }}
            style={{
              width: 6, height: 6, borderRadius: '50%', cursor: 'pointer',
              background: i === index ? '#22c55e' : 'rgba(148,163,184,.4)',
              transition: 'background .2s',
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default ImageCarousel
